function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleArrowDown = function SvgIconCircleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      fill: "var(--circle-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19c0-.55-.45-1-1-1s-1 .45-1 1zm-1.71.71c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 1 0-1.41-1.41L15 17.59l-5.66-5.66a.996.996 0 1 0-1.41 1.41zM14 19h2z",
    style: {
      fill: "var(--arrow-color)"
    }
  }));
};
export default SvgIconCircleArrowDown;